import Text, { TEXT_VARIANT } from '@pixum/text';

type CommercialRegisterProps = {
  constants: Record<string, string>;
};

export function CommercialRegister(props: CommercialRegisterProps) {
  const { constants } = props;
  const commercialRegisterInfo = constants.i18n_pixum_commercial_register_info;
  const showCommercialRegisterInfo = commercialRegisterInfo !== '';

  return (
    <>
      {showCommercialRegisterInfo && (
        <section className="footer__commercial-register-section" id="commercial-register">
          <Text variant={TEXT_VARIANT.CAPTION}>{constants.i18n_pixum_commercial_register_info}</Text>
        </section>
      )}
    </>
  );
}
